import { useSearchProductApi } from './useSearchProductApi';
import { useSearchProductGetters } from './useSearchProductGetters';

import type { UseSearchProduct } from './types';
export function useSearchProduct(): UseSearchProduct {
  return {
    ...useSearchProductApi(),
    ...useSearchProductGetters(),
    ...useSearchProductHelper(),
  };
}
